angular.module('jv.MyAccount.authApps.Ctrl', ['jv.AuthApps.Fac','jv.AuthApps.Namespace', 'jv.FacebookService', 'jv.App.DocuSignAuth.Svc'])
    .value('noop', angular.noop)
    .controller('authApps', ['$scope','$rootScope','$window','$route','AuthAppsNS', 'AuthAppsFac','AuthAppsFacPost','jvFacebookService','docuSignSvc','$location', authAppsController]);

function authAppsController($scope,$rootScope,$window,$route,namespace,AuthAppsFac,AuthAppsFacPost,jvFacebookService,docuSignSvc, $location) {
    var isFastRead = !!$route.current.params.fastRead;
    var facebookPermissions = ['public_profile'];
    $scope.docuSign={
        error: false
    };

    $rootScope.breadcrumbsConfig.links.unshift({
        linkText: i18n['AUTHAPPS'],
        link: $scope.jvUrls.admin+'/myaccount/profile.html#/authorizedApps'
    });

    $scope[namespace] = {fields: []};
    var avilableApps={0:'FB',1:'LI',2:'TW',6:'GMAIL',30:'YAHOO',55:'GCALENDAR',53:'TALENT',59:'HIRE',74:'BROADBEAN',75:'LINKEDIN_RSC', 77:'OFFICE_365', 72:'DOCUSIGN'};
    AuthAppsFac(namespace, isFastRead).then(function(data) {
        $scope[namespace].fields = data;
        $scope.flags.loading=false;
    }, function() {
        $scope[namespace].fields = [];
        $scope.flags.loading=false;
    });

    //Connect Apps
    $scope.connect=function(app){
        var redirectUrl;
        var returnUrl=$window.location.href;
        returnUrl=returnUrl.replace($window.location.hash,'#/authorizedApps');
        returnUrl=encodeURIComponent(returnUrl);
        $scope.platformId=angular.copy(app.platformId);
        if(app.platformId===1 || app.platformId===2 || app.platformId===30 || app.platformId===75 || (app.platformId===72 && window.enabledDocusignOAuth2 && window.enabledDocusignOAuth2 === 'true')){
        //LNKD, TWTR, YHOO
            redirectUrl=app.sourceBaseUrl;
            redirectUrl+=app.connectUrl;
            redirectUrl+='?action=connect&platform='+app.platformId;
            redirectUrl+='&returnurl='+returnUrl;
            $window.location=redirectUrl;
        }else if(app.platformId===53 || app.platformId===59){
        //TW , HR
            if(app.platformId===53){
                $scope.myaccountTalent=true;
            }else{
                $scope.myaccountHireright=true;
            }

        }else if(app.platformId===0){
        //Call FB
            facebookInitialized();
        }else if(app.platformId===55){
        //GOOG CAL
            redirectUrl=app.authUrl+'+'+returnUrl;
            $window.location=redirectUrl;
        }else if(app.platformId===6 || app.platformId===77){
        //GMAIL/Office 365
            redirectUrl=app.authUrl;
            $window.location=redirectUrl;
        }else if(app.platformId===72){
        //DOCUSIGN
            $scope.docuSign={
                error: false,
                validationError: false
            };
            $scope.myaccountDocuSign = true;
        }else if(app.platformId===74){
            $scope.myaccountBroadbean=true;
        }
    };

    $scope.disconnect=function(platformId){
        var data={action:'DISCONNECT'};
        AuthAppsFacPost(platformId, isFastRead, data)
        .then(function(){
            $scope.showMsg(avilableApps[platformId]+'_APP_DISCONNECTED');
            if($scope.params && !!$scope.params.fastRead){
                $route.reload();
            }else{
                $location.path('/authorizedApps/0');
            }
        }, function() {
            $scope.showMsg('UNABLE_TO_PERFORM',false,'error');
        });
    };

    $scope.cancel=function(flag){
        $scope[flag]=false;
        $scope.talWise={};
        $scope.hireRight={};
        $scope.broadbean={};
    };

    $scope.save=function(data, flag){
        data.action='CONNECT';
        AuthAppsFacPost($scope.platformId, isFastRead, data)
        .then(function(){
            $scope.cancel(flag);
            $scope.showMsg(avilableApps[$scope.platformId]+'_APP_CONNECTED');
            if($scope.params && !!$scope.params.fastRead){
                $window.location.reload();
            }else{
                $location.path('/authorizedApps/0');
            }
        }, function() {
            $scope.cancel(flag);
            $scope.showMsg('UNABLE_TO_PERFORM',false,'error');
        });
    };

    $scope.saveDocuSign = function(data, flag){
        delete $scope.docuSign.error;
        $scope.docuSign.validationError = false;
        if($scope.isNullOrEmpty(data.username) || $scope.isNullOrEmpty(data.password) || $scope.isNullOrEmpty(data.accountId)){
            $scope.docuSign.validationError = true;
            return;
        }
        docuSignSvc.saveDocuSign(data, flag, function(res){
            if(res.data.docuSignOAuthStatus){
                if(res.data.docuSignOAuthStatus.errorCode === 'OK'){
                    $scope.cancel('myaccountDocuSign');
                    $window.location.reload();
                }else{
                    $scope.docuSign.error=res.data.docuSignOAuthStatus.message;
                }
            }
        });
    };

    $scope.isNullOrEmpty = function(obj){
        if(!obj){
            return true;
        }
        if(typeof(obj) === 'string' && obj.length === 0){
            return true;
        }
        return false;
    };

    //FaceBook Methods
    function facebookInitialized() {
        jvFacebookService.authorize(facebookPermissions, facebookConnectedPermissionsGranted);
    }

    function facebookConnectedPermissionsGranted(err, response){
        // VA: facebook no longer supports offline access and is restricted to 60 days.
        if (!err && response.authResponse && response.authResponse.expiresIn !== 0 && jvFacebookService.hasPermissions(facebookPermissions.slice(0,1), true)){
            facebookSaveConnection(response.authResponse);
        }
    }

    function facebookSaveConnection(session) {
        var data={};
        data.action='CONNECT';
        data.socId=session.userID;
        data.sSec=session.accessToken;
        AuthAppsFacPost($scope.platformId, isFastRead, data)
        .then(function(){
            $scope.showMsg(avilableApps[$scope.platformId]+'_APP_CONNECTED');
            $route.reload();
        }, function() {
            $scope.showMsg('UNABLE_TO_PERFORM',false,'error');
        });
    }
}
